module.exports = __webpack_public_path__ + "static/img/RAS4_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAS4_1.png
// module id = yaS5
// module chunks = 0